import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    class: 'd-flex flex-column flex-grow-1'
  }
})
export class AppComponent {
  title = 'Pasarela-Andes-Motor';
}
